// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_BEGIN_CHECKOUT = 'uiState/tracking/SET_BEGIN_CHECKOUT';

export const setBeginCheckout = (beginCheckout: boolean): PureAction => ({
  type: PURE(SET_BEGIN_CHECKOUT),
  beginCheckout,
});
